import request from '@/utils/request.js'

export const GetMyShopList = function(data) {
	return request.get("/open/list", data);
}
export const AddShop = function(data) {
	return request.post("/open/add", data);
}
export const AuthShop = function(data) {
	return request.post("/open/auth", data);
}
export const AddProduct = function(data) {
	return request.post("/open/add-product", data);
}
export const GetShopInfo = function(data) {
	return request.get("/open/get-shop-info", data);
}
export const GetCateConfig = function(data) {
	return request.get("/open/get-cate-config", data);
}
export const GetCategoryPropSearch = function(data) {
	return request.get("/open/getCategoryPropSearch", data);
}


